module.exports = __webpack_public_path__ + "img/toolbar_bg1.4201b343.png";